import { Component } from '@angular/core';
import { TemplatesService } from '../templates/templates.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-preferances',
  templateUrl: './add-preferances.component.html',
  styleUrls: ['./add-preferances.component.css']
})
export class AddPreferancesComponent {
  selectedFrequency: string = '3'; // Default value for select dropdown
  sendEmail: boolean = false; // Default value for sendEmail
  selectedGrade: string = 'L4';
  constructor(private _templateService: TemplatesService, private toastr: ToastrService) { }
  ngOnInit(){
    this.GetEmailConfiguration();
  }

  submitForm() {
    this._templateService.AddOrUpdateEmailConfiguaration(this.selectedGrade, this.sendEmail, this.selectedFrequency).subscribe(res=>{
      if(res){
        this.toastr.success("Email Preference submitted")
      }
    })
  }
  GetEmailConfiguration(){
    this._templateService.GetEmailConfiguration().subscribe(res => {
      this.sendEmail = res.isSendEmail;
      this.selectedFrequency = res.frequencyInMonths;
      this.selectedGrade = res.grade;
    });
  }
}
